export enum COURSE_MODE {
  EDIT = 'EDIT',
  VIEWER = 'VIEWER'
}